<!-- 
<div class="container-fluid">
  <div class="col-md-12 p-0">
    <table class="table table-bordered table-sm text-center align-middle">
  <thead>
    <tr>
      <th rowspan="2">No.</th>
      <th rowspan="2">વિગત</th>
      <th rowspan="2">કુલ આંગણવાડી કેન્દ્રોની સંખ્યા</th>
      <th colspan="2">આંગણવાડી ખુલ્લું છે?</th>
      <th rowspan="2">સવારનો નાસ્તો મેળવનાર બાળકોની સંખ્યા</th>
      <th colspan="2">સવારના નાસ્તાની ડીશનો ફોટો</th>
      <th colspan="2">બાળકોનો સવારનો નાસ્તો લેતા ફોટો</th>
      <th rowspan="2">દૂધ સંજીવનીમાં આવેલ પાઉચની સંખ્યા</th>
      <th colspan="2">દૂધ સંજીવની યોજનાનો લાભ લેતા ફોટો</th>
      <th rowspan="2">બપોરનો નાસ્તો મેળવનાર બાળકોની સંખ્યા</th>
      <th colspan="2">બપોરના નાસ્તાની ડીશનો ફોટો</th>
      <th colspan="2">બપોરનો નાસ્તો જમતા બાળકોનો ફોટો</th>
      <th rowspan="2">પોષણ સુધા ડીશનો ફોટો</th>
      <th colspan="2">પોષણ સુધા લાભ લેતાનો ફોટો</th>
      <th rowspan="2">પૂર્વ પ્રાથમિક શિક્ષણ આપેલ બાળકોની સંખ્યા</th>
      <th colspan="2">પૂર્વ પ્રાથમિક શિક્ષણ ફોટો</th>
    </tr>
    <tr>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
      <th>હા</th>
      <th>ના</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of dahodDataList; let i = index">
      <td>{{ i + 1 }}</td>
      <td>{{ row.region }}</td>
      <td>{{ row.totalCenters }}</td>
      <td>{{ row.openCentersYes }}</td>
      <td>{{ row.openCentersNo }}</td>
      <td>{{ row.morningMealCount }}</td>
      <td>{{ row.morningDishYes }}</td>
      <td>{{ row.morningDishNo }}</td>
      <td>{{ row.childrenMorningMealYes }}</td>
      <td>{{ row.childrenMorningMealNo }}</td>
      <td>{{ row.milkPouchCount }}</td>
      <td>{{ row.photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes }}</td>
      <td>{{ row.photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes }}</td>
      <td>{{ row.afternoonMealCount }}</td>
      <td>{{ row.afternoonDishYes }}</td>
      <td>{{ row.afternoonDishNo }}</td>
      <td>{{ row.afternoonEatYes }}</td>
      <td>{{ row.afternoonEatNo }}</td>
      <td>{{ row.poshanDish }}</td>
      <td>{{ row.photoOfBeneficiariesPresentForTheNutritionEnhancementYes }}</td>
      <td>{{ row.photoOfBeneficiariesPresentForTheNutritionEnhancementNo  }}</td>
      <td>{{ row.preEducationCount }}</td>
      <td>{{ row.preEducationYes }}</td>
      <td>{{ row.preEducationNo }}</td>
    </tr>
  </tbody>
</table>
  </div> 
</div> -->




<div class="container-fluid mt-4">
  <div class="card shadow rounded-4 border-0">
    <div class="card-header bg-secondary text-white fw-semibold fs-5 rounded-top-4">
      આંગણવાડી કેન્દરોની વિગતવાર માહિતી
    </div>
    <!-- Date Range Filter -->
    <div class="p-3">
      <div class="row g-2 align-items-end">
        <div class="col-md-2">
          <label for="fromDate" class="form-label">તારીખથી (From Date)</label>
          <input type="date" id="fromDate" class="form-control" [(ngModel)]="form['startDate']">
        </div>
        <div class="col-md-2">
          <label for="toDate" class="form-label">તારીખ સુધી (To Date)</label>
          <input type="date" id="toDate" class="form-control" [(ngModel)]="form['endDate']">
        </div>
        <!-- Area Dropdown -->
        <div class="col-md-3">
          <label for="areaSelector" class="form-label">વિસ્તાર પસંદ કરો (District / Block / Sector)</label>
          <select id="areaSelector" class="form-select" [(ngModel)]="tempSelectedArea">
            <option selected [value]="'sector'">-વિસ્તાર પસંદ કરો-</option>
            <option *ngFor="let area of areaOptions" [value]="area.value">{{ area.label }}</option>
          </select>
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-primary mt-2" (click)="onFilter()">ફિલ્ટર કરો</button>
          <button class="btn btn-primary mt-2" (click)="exportPDFData()">ડાઉનલોડ PDF</button>
        </div>


      </div>
    </div>

    <div>
      <div class="table-responsive-container">
        <table class="table table-bordered table-sm text-center align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th class="sticky-col first-col" rowspan="2">No.</th>
              <ng-container *ngIf="form.selectedArea === 'district'">
                <th class="sticky-col second-col" rowspan="2">જિલ્લો</th>
                <th class="sticky-col third-col" rowspan="2">કુલ બ્લોક</th>
                <th class="sticky-col fourth-col" rowspan="2">કુલ સેજા</th>
                <th class="sticky-col fifth-col" rowspan="2">કુલ આંગણવાડી કેન્દ્રોની સંખ્યા</th>
              </ng-container>
              <ng-container *ngIf="form.selectedArea === 'block'">
                <th class="sticky-col second-col" rowspan="2">બ્લોક</th>
                <th class="sticky-col third-col" rowspan="2">કુલ સેજા</th>
                <th class="sticky-col fourth-col" rowspan="2">કુલ આંગણવાડી કેન્દ્રોની સંખ્યા</th>
              </ng-container>
              <ng-container *ngIf="form.selectedArea === 'sector'">
                <th class="sticky-col second-col" rowspan="2">સેજા</th>
                <th class="sticky-col third-col" rowspan="2">કુલ આંગણવાડી કેન્દ્રોની સંખ્યા</th>
              </ng-container>
              <th colspan="2">આંગણવાડી ખુલ્લું છે?</th>
              <th rowspan="2">સવારનો નાસ્તો મેળવનાર બાળકોની સંખ્યા</th>
              <th colspan="2">સવારના નાસ્તાની ડીશનો ફોટો</th>
              <th colspan="2">બાળકોનો સવારનો નાસ્તો લેતા ફોટો</th>
              <th rowspan="2">દૂધ સંજીવની લાભ લેતા બાળકો</th>
              <th colspan="2">દૂધ સંજીવની ફોટો</th>
              <th rowspan="2">બપોરનો નાસ્તો મેળવનાર બાળકોની સંખ્યા</th>
              <th colspan="2">બપોરના નાસ્તાની ડીશ</th>
              <th colspan="2">બપોરનો નાસ્તો જમતા બાળકોનો ફોટો</th>
              <th rowspan="2">પોષણ સુધા યોજનાનો લાભ લેતા લાભાર્થીની સંખ્યા</th>
              <th colspan="2">પોષણ સુધા લાભ ફોટો</th>
              <th rowspan="2">પૂર્વ પ્રાથમિક શિક્ષણ આપેલ બાળકો</th>
              <th colspan="2">પૂર્વ પ્રાથમિક શિક્ષણ ફોટો</th>
              <th colspan="3">ભોજનની ગુણવત્તા</th>
            </tr>

            <tr class="header">
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>હા</th>
              <th>ના</th>
              <th>સારી</th>
              <th>મધ્યમ</th>
              <th>ખરાબ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of dahodDataList; let i = index">
              <td class="sticky-col first-col">{{ i + 1 }}</td>

              <!-- District level -->
              <ng-container *ngIf="form.selectedArea == 'district'">
                <td class="sticky-col second-col">Dahod</td>
                <td class="sticky-col third-col">{{ row.totalBlock }}</td>
                <td class="sticky-col fourth-col">{{ row.totalSector }}</td>
                <td class="sticky-col fifth-col">{{ row.totalCenter }}</td>
              </ng-container>

              <!-- Block level -->
              <ng-container *ngIf="form.selectedArea == 'block'">
                <td class="sticky-col second-col">{{ row.blockName }}</td>
                <td class="sticky-col third-col">{{ row.totalSector }}</td>
                <td class="sticky-col fourth-col">{{ row.totalCenter }}</td>
              </ng-container>

              <!-- Sector level -->
              <ng-container *ngIf="form.selectedArea == 'sector'">
                <td class="sticky-col second-col">{{ row.sectorName }}</td>
                <td class="sticky-col third-col">{{ row.totalCenter }}</td>
              </ng-container>

              <!-- Scrollable Columns -->
              <td>{{ row.openCentersYes }}</td>
              <td>{{ row.openCentersNo }}</td>
              <td>{{ row.morningMealCount }}</td>
              <td>{{ row.morningDishYes }}</td>
              <td>{{ row.morningDishNo }}</td>
              <td>{{ row.childrenMorningMealYes }}</td>
              <td>{{ row.childrenMorningMealNo }}</td>
              <td>{{ row.milkPouchCount }}</td>
              <td>{{ row.photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes }}</td>
              <td>{{ row.photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo }}</td>
              <td>{{ row.afternoonMealCount }}</td>
              <td>{{ row.afternoonDishYes }}</td>
              <td>{{ row.afternoonDishNo }}</td>
              <td>{{ row.afternoonEatYes }}</td>
              <td>{{ row.afternoonEatNo }}</td>
              <td>{{ row.poshanDish }}</td>
              <td>{{ row.photoOfBeneficiariesPresentForTheNutritionEnhancementYes }}</td>
              <td>{{ row.photoOfBeneficiariesPresentForTheNutritionEnhancementNo }}</td>
              <td>{{ row.preEducationCount }}</td>
              <td>{{ row.preEducationYes }}</td>
              <td>{{ row.preEducationNo }}</td>
              <td>{{ row.qualityOfHotSnacksAndNutritionEnhancedMealsGood }}</td>
              <td>{{ row.qualityOfHotSnacksAndNutritionEnhancedMealsAverage }}</td>
              <td>{{ row.qualityOfHotSnacksAndNutritionEnhancedMealsBad }}</td>
            </tr>

            <!-- Total Row -->
            <tr class="table-secondary fw-bold">
              <td class="sticky-col first-col"></td>

              <!-- District level summary -->
              <ng-container *ngIf="form.selectedArea === 'district'">
                <td class="sticky-col second-col">Total</td>
                <td class="sticky-col third-col">
                  {{ getTotal('totalBlock') }}<br />
                  <small class="text-muted">({{ getPercentageOfCenters('totalBlock',21) }})</small>
                </td>
                <td class="sticky-col fourth-col">
                  {{ getTotal('totalSector') }}<br />
                  <small class="text-muted">({{ getPercentageOfCenters('totalSector',122) }})</small>
                </td>
                <td class="sticky-col fifth-col">
                  {{ getTotal('totalCenter') }}<br />
                  <small class="text-muted">({{ getPercentageOfCenters('totalCenter', 3056) }})</small>
                </td>
              </ng-container>

              <!-- Block level summary -->
              <ng-container *ngIf="form.selectedArea === 'block'">
                <td class="sticky-col second-col">Total</td>
                <td class="sticky-col third-col">
                  {{ getTotal('totalSector') }}<br />
                  <small class="text-muted">({{ getPercentageOfCenters('totalSector',122) }})</small>
                </td>
                <td class="sticky-col fourth-col">
                  {{ getTotal('totalCenter') }}<br />
                  <small class="text-muted">({{ getPercentageOfCenters('totalCenter', 3056) }})</small>
                </td>
              </ng-container>

              <!-- Sector level summary -->
              <ng-container *ngIf="form.selectedArea === 'sector'">
                <td class="sticky-col second-col">Total</td>
                <td class="sticky-col third-col">
                  {{ getTotal('totalCenter') }}<br />
                  <small class="text-muted">({{ getPercentageOfCenters('totalCenter',3056) }})</small>
                </td>
              </ng-container>

              <!-- Scrollable Total Columns -->
              <td>
                {{ getTotal('openCentersYes') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('openCentersYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('openCentersNo') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('openCentersNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('morningMealCount') }}
              </td>
              <td>
                {{ getTotal('morningDishYes') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('morningDishYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('morningDishNo') }}
              </td>
              <td>
                {{ getTotal('childrenMorningMealYes') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('childrenMorningMealYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('childrenMorningMealNo') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('childrenMorningMealNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('milkPouchCount') }}
              </td>
              <td>
                {{ getTotal('photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes') }}<br />
                <small class="text-muted">({{
                  getPercentageOfCenters('photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo') }}<br />
                <small class="text-muted">({{
                  getPercentageOfCenters('photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('afternoonMealCount') }}
              </td>
              <td>
                {{ getTotal('afternoonDishYes') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('afternoonDishYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('afternoonDishNo') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('afternoonDishNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('afternoonEatYes') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('afternoonEatYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('afternoonEatNo') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('afternoonEatNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('poshanDish') }}
              </td>
              <td>
                {{ getTotal('photoOfBeneficiariesPresentForTheNutritionEnhancementYes') }}<br />
                <small class="text-muted">({{
                  getPercentageOfCenters('photoOfBeneficiariesPresentForTheNutritionEnhancementYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('photoOfBeneficiariesPresentForTheNutritionEnhancementNo') }}<br />
                <small class="text-muted">({{
                  getPercentageOfCenters('photoOfBeneficiariesPresentForTheNutritionEnhancementNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('preEducationCount') }}
              </td>
              <td>
                {{ getTotal('preEducationYes') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('preEducationYes',3056) }})</small>
              </td>
              <td>
                {{ getTotal('preEducationNo') }}<br />
                <small class="text-muted">({{ getPercentageOfCenters('preEducationNo',3056) }})</small>
              </td>
              <td>
                {{ getTotal('qualityOfHotSnacksAndNutritionEnhancedMealsGood') }}
              </td>
              <td>
                {{ getTotal('qualityOfHotSnacksAndNutritionEnhancedMealsAverage') }}
              </td>
              <td>
                {{ getTotal('qualityOfHotSnacksAndNutritionEnhancedMealsBad') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>



</div>